/**
 * In-memory patient session, shared across the public request/offer flows within
 * a single SPA session (M12 medicines, M14 appointments).
 *
 * Deliberately NOT persisted — no localStorage, no sessionStorage, not the URL
 * (CLAUDE.md: view preference may persist, tokens never). It lives only for as
 * long as the tab is open, so:
 *   - tapping "Track your request" right after verifying reuses the session
 *     (no pointless second OTP);
 *   - a page reload, a new tab, or a fresh SMS deep-link correctly has no
 *     session and re-verifies — the owner-gated offer stays protected.
 *
 * The backend still authorises every read against the token AND the owning
 * `user_id`, so a cached session only ever spares re-auth for the same person;
 * it can never widen what that person may see.
 */
import type { PatientSession } from '../api/patientAuth'

let current: PatientSession | null = null

export function getPatientSession(): PatientSession | null {
  return current
}

export function setPatientSession(session: PatientSession | null): void {
  current = session
}
